export const PAGE_TITLE = {
    SHOP: 'Shop - Procure',
    ADD_AFFILIATE_CONFIGURATION: 'Add Affiliate Configuration - Procure',
    EDIT_AFFILIATE_CONFIGURATION: 'Edit Affiliate Configuration - Procure',
    AFFILIATE_CONFIGURATION: 'Affiliate Configuration - Procure',
  };
  